/* California-only visibility for explicitly enabled Prop 65 notices. */
(() => {
  'use strict';

  if (window.prop65) {
    window.prop65.refresh();
    return;
  }

  const selector = '[data-prop-65]';
  const usRegions = new Set(('AL AK AZ AR CA CO CT DE DC FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI WY AS GU MP PR UM VI').split(' '));
  let result;

  function classify(region) {
    // Accept Shopify's documented format only, not country selectors or US-CA.
    if (typeof region !== 'string' || !/^[A-Z]{2}[A-Z0-9]{0,3}$/.test(region)) return 'unknown';
    if (region.slice(0, 2) === 'ZZ') return 'unknown';
    if (region === 'USCA') return 'california';
    if (region.slice(0, 2) !== 'US') return 'non-california';
    return usRegions.has(region.slice(2)) ? 'non-california' : 'unknown';
  }

  function locate() {
    return new Promise((resolve) => {
      let finished = false;
      let requested = false;
      let retry;
      const deadline = window.setTimeout(() => finish('unknown'), 3000);

      function finish(status) {
        if (finished) return;
        finished = true;
        window.clearTimeout(deadline);
        window.clearTimeout(retry);
        resolve(status);
      }

      function check() {
        if (finished) return;
        const shopify = window.Shopify;
        const privacy = shopify?.customerPrivacy;
        try {
          if (typeof privacy?.getRegion === 'function') {
            const status = classify(privacy.getRegion());
            if (status !== 'unknown') {
              finish(status);
              return;
            }
          } else if (!requested && typeof shopify?.loadFeatures === 'function') {
            requested = true;
            shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
              if (error) finish('unknown');
              // The bounded polling loop reads the API after the callback.
            });
          }
        } catch (error) {
          finish('unknown');
        }
        if (!finished) retry = window.setTimeout(check, 100);
      }

      check();
    });
  }

  function refresh() {
    if (!document.querySelector(selector)) return;
    // Share pending/successful lookups; allow a later refresh to retry unknown.
    if (!result) {
      result = locate().then((status) => {
        if (status === 'unknown') result = undefined;
        return status;
      });
    }
    result.then((status) => {
      document.querySelectorAll(selector).forEach((node) => {
        node.dataset['prop-65Status'] = status;
        // Unknown and no-JS remain hidden pending the production policy.
        node.hidden = status !== 'california';
      });
    });
  }

  window.prop65 = { classify, refresh };
  document.addEventListener('shopify:section:load', refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();
